export default {
  sendErrors: 'handleErrors',
  sendRoutes: 'requestRoutes',
  logSuccess: 'logSuccess',
  logError: 'logError'
}
